<template>
  <header class="header">
    <div v-if="backLink || homeLink" class="header__links">
      <BaseIconButton
        v-if="backLink"
        icon="back"
        :href="backLink"
        class="header__link"
      />
      <BaseIconButton
        v-if="homeLink"
        icon="home"
        :href="homeLink"
        class="header__link"
      />
    </div>
  </header>
</template>

<script>
import BaseIconButton from '@/components/BaseIconButton.vue';

export default {
  name: 'TheHeader',
  components: {
    BaseIconButton,
  },
  computed: {
    backLink() {
      const { back = '' } = this.$route.meta || {};
      return back;
    },
    homeLink() {
      const { home } = this.$route.meta || {};
      return home ? this.$router.options.paths.home : '';
    },
  },
};
</script>

<style lang="stylus">
.header
  display flex
  align-items center
  padding-left $side_padding
  padding-right @padding-left

  &__links
    display flex
    justify-content space-between
    width 6em
    pointer-events auto
    .screen_header_hidden ~ .app__header &
      visibility hidden
</style>
